module.exports = __webpack_public_path__ + "static/img/4.aa3fe44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/1/4.png
// module id = InQ9
// module chunks = 1